// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { setupAPIInstanceInterceptor } from '@/api/authorizedAPI';
import { router } from './app/router';

import { store } from './app/store';

import '@yaradigitallabs/ahua-react/fonts/noto-sans/font-face.css';
import '@yaradigitallabs/ahua-react/fonts/yara-max/font-face.css';
import './index.css';
import { NotificationProvider } from './components/Notification/useNotification.tsx';

setupAPIInstanceInterceptor();

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Provider store={store}>
    {/* <AhuaProvider> */}
    <NotificationProvider>
      <RouterProvider router={router} />
    </NotificationProvider>
    {/* </AhuaProvider> */}
  </Provider>
  // </StrictMode>
);
